export const hcoCardStyles = {
	root: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: 2,
		px: 2,
		py: 0.75,
		width: '100%',
		color: 'text.fadedPrimary',
		textDecoration: 'none',
		cursor: 'pointer',

		'&:focus': {
			backgroundColor: 'primary.hover',
			outline: 'none'
		},
		'&:hover': {
			backgroundColor: 'primary.hover'
		}
	},

	mainContentContainer: {
		display: 'flex',
		flexDirection: 'column',
		flex: 1,
		gap: 0.5,
		minWidth: 0
	},

	name: {
		fontSize: 'clamp(1rem, 1rem, 1.5rem)',
		lineHeight: '150%',
		letterSpacing: '.15px',
		fontWeight: 700,
		p: 0,
		m: 0
	},

	address: {
		fontSize: '.875rem',
		fontWeight: 400,
		lineHeight: '140%',
		maxWidth: '100%',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap'
	},

	compactAddress: {
		fontSize: '.875rem',
		fontWeight: 400,
		lineHeight: '140%'
	},

	textRow: {
		display: 'flex',
		flexDirection: 'row',
		minWidth: 0
	},

	iconContainer: {
		backgroundColor: 'primary.lighter',
		width: 40,
		height: 40,
		borderRadius: '50%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flex: '0 0 auto'
	},

	chipRow: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: 1,
		alignItems: 'center',
		verticalAlign: 'middle',
		fontWeight: 400,
		flexShrink: 0,
		my: 1
	}
};
